import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { CardBookingInfo as CardBookingInfo$2, CardContentUpper, CardContentLower, InfoList, InfoListItem } from './CardBookingInfo.style.js';
import Ratings from './Ratings.js';
import { ICON_TIME_LOCATION_HOTEL_BED } from '../../../icons/ICON_TIME_LOCATION_HOTEL_BED.js';
import { ICON_TRAVEL_BAGGAGE } from '../../../icons/ICON_TRAVEL_BAGGAGE.js';
import { ICON_UI_USER } from '../../../icons/ICON_UI_USER.js';
import { ICON_TIME_LOCATION_CALENDAR } from '../../../icons/ICON_TIME_LOCATION_CALENDAR.js';
import { ICON_TRAVEL_AIRPLANE } from '../../../icons/ICON_TRAVEL_AIRPLANE.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import useIsGlobetrotter from '../../../hooks/useIsGlobetrotter.js';
import Title from './Title.js';
import Subtitle from './Subtitle.js';
import Icon from '../../Icon/Icon.js';
import Typography from '../../Typography/Typography.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var CardBookingInfo = function CardBookingInfo(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? null : _ref$title,
    _ref$headingLevel = _ref.headingLevel,
    headingLevel = _ref$headingLevel === void 0 ? null : _ref$headingLevel,
    _ref$subtitle = _ref.subtitle,
    subtitle = _ref$subtitle === void 0 ? null : _ref$subtitle,
    _ref$rating = _ref.rating,
    rating = _ref$rating === void 0 ? null : _ref$rating,
    _ref$ratingPrefix = _ref.ratingPrefix,
    ratingPrefix = _ref$ratingPrefix === void 0 ? null : _ref$ratingPrefix,
    _ref$tripadvisorRatin = _ref.tripadvisorRating,
    tripadvisorRating = _ref$tripadvisorRatin === void 0 ? null : _ref$tripadvisorRatin,
    _ref$guestRating = _ref.guestRating,
    guestRating = _ref$guestRating === void 0 ? null : _ref$guestRating,
    _ref$travelType = _ref.travelType,
    travelType = _ref$travelType === void 0 ? null : _ref$travelType,
    _ref$durationText = _ref.durationText,
    durationText = _ref$durationText === void 0 ? null : _ref$durationText,
    _ref$departureName = _ref.departureName,
    departureName = _ref$departureName === void 0 ? null : _ref$departureName,
    _ref$paxText = _ref.paxText,
    paxText = _ref$paxText === void 0 ? null : _ref$paxText,
    _ref$room = _ref.room,
    room = _ref$room === void 0 ? null : _ref$room,
    _ref$url = _ref.url,
    url = _ref$url === void 0 ? null : _ref$url,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? null : _ref$onClick,
    _ref$onClickElementPr = _ref.onClickElementProps,
    onClickElementProps = _ref$onClickElementPr === void 0 ? null : _ref$onClickElementPr,
    cardSettings = _ref.cardSettings;
  var isGlobetrotter = useIsGlobetrotter();
  var hasNoRatings = !rating && !tripadvisorRating && !guestRating;
  return /*#__PURE__*/jsxs(CardBookingInfo$2, _objectSpread(_objectSpread({}, cardSettings), {}, {
    children: [/*#__PURE__*/jsxs(CardContentUpper, _objectSpread(_objectSpread({}, cardSettings), {}, {
      children: [title && /*#__PURE__*/jsx(Title, {
        clickable: true,
        className: "uikit-card-content-title",
        titleLinkProps: onClickElementProps,
        url: url,
        onClick: onClick,
        headingLevel: headingLevel,
        children: title
      }), subtitle && /*#__PURE__*/jsx(Subtitle, {
        children: subtitle
      }), !hasNoRatings && /*#__PURE__*/jsx(Ratings, {
        rating: rating,
        ratingPrefix: ratingPrefix,
        guestRating: guestRating,
        tripadvisorRating: tripadvisorRating
      })]
    })), /*#__PURE__*/jsx(CardContentLower, _objectSpread(_objectSpread({}, cardSettings), {}, {
      children: /*#__PURE__*/jsxs(InfoList, {
        children: [travelType && /*#__PURE__*/jsxs(InfoListItem, {
          children: [!isGlobetrotter && /*#__PURE__*/jsx(Icon, {
            path: ICON_TRAVEL_BAGGAGE,
            size: "xs"
          }), /*#__PURE__*/jsx(Typography, {
            children: travelType
          })]
        }), durationText && /*#__PURE__*/jsxs(InfoListItem, {
          children: [!isGlobetrotter && /*#__PURE__*/jsx(Icon, {
            path: ICON_TIME_LOCATION_CALENDAR,
            size: "xs"
          }), /*#__PURE__*/jsx(Typography, {
            children: durationText
          })]
        }), departureName && /*#__PURE__*/jsxs(InfoListItem, {
          children: [!isGlobetrotter && /*#__PURE__*/jsx(Icon, {
            path: ICON_TRAVEL_AIRPLANE,
            size: "xs"
          }), /*#__PURE__*/jsx(Typography, {
            children: departureName
          })]
        }), paxText && /*#__PURE__*/jsxs(InfoListItem, {
          children: [!isGlobetrotter && /*#__PURE__*/jsx(Icon, {
            path: ICON_UI_USER,
            size: "xs"
          }), /*#__PURE__*/jsx(Typography, {
            children: paxText
          })]
        }), room && /*#__PURE__*/jsxs(InfoListItem, {
          children: [!isGlobetrotter && /*#__PURE__*/jsx(Icon, {
            path: ICON_TIME_LOCATION_HOTEL_BED,
            size: "xs"
          }), /*#__PURE__*/jsx(Typography, {
            children: room
          })]
        })]
      })
    }))]
  }));
};
var CardBookingInfo$1 = CardBookingInfo;

export { CardBookingInfo$1 as default };
//# sourceMappingURL=CardBookingInfo.js.map
